import {
  AppState,
  updateAuthenticationFailureMessage,
  updateCurrentStateWithSelectionUIProps
} from "../redux/AppStateSlice";
import {includes} from "lodash";
import {errorMessages} from "./CustomFormSession";
import {AppDispatch} from "../redux/store";
import {ClientContextObject} from "../redux";
import {getLogger} from "../logConfig";

import {S} from "./sdk";

const logger = getLogger("PasswordAuthenticatorSession");

export class PasswordAuthenticatorSession implements com.ts.mobile.sdk.UIAuthenticatorSession<com.ts.mobile.sdk.PasswordInput> {
  title: string;
  username: string;
  mode: com.ts.mobile.sdk.AuthenticatorSessionMode | null;
  description: com.ts.mobile.sdk.AuthenticatorDescription | null;
  actionContext: com.ts.mobile.sdk.PolicyAction | null;
  uiContext: com.ts.mobile.sdk.UIContext | null;
  clientContext: ClientContextObject | null;
  dispatch: AppDispatch;

  constructor(title: string, username: string, dispatch: AppDispatch) {
    this.title = title;
    this.username = username;
    this.dispatch = dispatch;
    this.mode = null;
    this.description = null;
    this.actionContext = null;
    this.uiContext = null;
    this.clientContext = null;
  }
  startSession(description: com.ts.mobile.sdk.AuthenticatorDescription, mode: com.ts.mobile.sdk.AuthenticatorSessionMode, actionContext: com.ts.mobile.sdk.PolicyAction | null, clientContext: object | null): void {
    logger.debug(`Started new ${S.AuthenticatorSessionMode[mode]} ${this.title} session`);
    this.description = description;
    this.mode = mode;
    this.actionContext = actionContext;
    this.uiContext = actionContext?.getUiContext() || null;
    this.clientContext = clientContext as any;
  }

  changeSessionModeToRegistrationAfterExpiration(): void {
    logger.debug("Changing session mode to registration after expiration");
    this.mode = S.AuthenticatorSessionMode.Registration;
  }

  endSession(): void {
    logger.debug(`Ended ${S.AuthenticatorSessionMode[this.mode as any]} ${this.title} session`);
  }

  promiseInput(): Promise<com.ts.mobile.sdk.InputOrControlResponse<com.ts.mobile.sdk.PasswordInput>> {
    if (this.mode === S.AuthenticatorSessionMode.Authentication) {
      logger.debug(`Fetching ${this.title} authentication input`);
      return new Promise((resolve) => {
        let password = this.clientContext?.password || "";
        resolve(com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(com.ts.mobile.sdk.PasswordInput.create(password)));
      });
    } else {
      throw new Error("No Password Authenticator Input implemented for Mode:" + this.mode);
    }
  }

  promiseRecoveryForError(error: com.ts.mobile.sdk.AuthenticationError, validRecoveries: Array<com.ts.mobile.sdk.AuthenticationErrorRecovery>, defaultRecovery: com.ts.mobile.sdk.AuthenticationErrorRecovery): Promise<com.ts.mobile.sdk.AuthenticationErrorRecovery> {
    logger.debug(`Starting error recovery with default recovery: ${defaultRecovery}; mode: [${S.AuthenticatorSessionMode[this.mode as any]}], error: [${error}]`);
    let errorData: any = error.getData();
    if (includes(validRecoveries, S.AuthenticationErrorRecovery.RetryAuthenticator) &&
      error.getData() && errorData.additional_data && errorData.additional_data.errors
    ) {
      let error = errorData.additional_data.errors[0];
      let failureMessage = errorMessages[`${error.code}`];

      this.dispatch(updateAuthenticationFailureMessage(failureMessage));
      return Promise.resolve(S.AuthenticationErrorRecovery.Fail);
    } else {
      throw new Error("No Valid Recovery implemented for error:" + error.getData());
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  promiseCancelAction(options: any[], clientContext: ClientContextObject | null) {
    logger.debug("About to show options after user clicked cancel");

    const getTitle = (option: any) => {
      switch (option) {
        case S.ControlRequestType.ChangeMethod:
          return "Change Authentication Method";
        case S.ControlRequestType.SelectMethod:
          return "Show All Authentication Methods";
        case S.ControlRequestType.RetryAuthenticator:
          return "Retry Authenticator";
        case S.ControlRequestType.AbortAuthentication:
          return "Abort Authentication";
      }
    };

    const menuItems = options.map((option) => {
      return {
        title: getTitle(option) as string,
        value: S.ControlRequest.create(option)
      }
    });
    return new Promise((resolve) => {
      this.dispatch(updateCurrentStateWithSelectionUIProps({
        state: AppState.SELECTION_UI,
        props: {items: menuItems, instructions: "Choose Your next Action", resolve}
      }))
    })
  }
}